import ServicePageTemplate from './ServicePageTemplate';
import { bcaInternshipIndustrialProjectGuidanceConfig } from './trainingPageConfigs';

const BcaInternshipIndustrial = () => (
  <ServicePageTemplate {...bcaInternshipIndustrialProjectGuidanceConfig} />
);

export default BcaInternshipIndustrial;
